/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_Faq_Q3Inputs */

const en_simple_oto_faq_q3 = /** @type {(inputs: Simple_Oto_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who owns the app?`)
};

const id_simple_oto_faq_q3 = /** @type {(inputs: Simple_Oto_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapa pemilik aplikasinya?`)
};

/**
* | output |
* | --- |
* | "Who owns the app?" |
*
* @param {Simple_Oto_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_faq_q3 = /** @type {((inputs?: Simple_Oto_Faq_Q3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_Faq_Q3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_faq_q3(inputs)
	return en_simple_oto_faq_q3(inputs)
});